module.exports = __webpack_public_path__ + "img/deposit_basic-account.8aeb9788.png";